import { Avatar } from '@customerio/pluma-components/react';
import { useAuth, useCurrentUserId } from '@/services/auth';
import { useAccountUser } from '@/services/db/user/queries';
import { displayNameOf } from '@/services/db/user/user-display';
import { isEmptyString } from '@/utils/string';

/** The current user's avatar, shown next to their own chat messages. Falls back to initials when there's no uploaded photo. */
export function ChatUserAvatar() {
  const auth = useAuth();
  const currentUserId = useCurrentUserId();
  // Only the account-user record carries profile_image_url; the auth store supplies the
  // name so initials show immediately and survive a failed lookup.
  const { data: user } = useAccountUser(auth.account.id, String(currentUserId));

  const authName = !isEmptyString(auth.user.name) ? auth.user.name : auth.user.email;
  const name = user != null ? displayNameOf(user) : authName;

  return <Avatar size="sm" name={name} src={user?.profile_image_url ?? undefined} />;
}
